module.exports = __webpack_public_path__ + "files/cde7472554626f292761f57207f624f6.png";